// INDIA-GUJARATI

export const locale = {
    Action: 'ક્રિયા',
    Submit: 'સબમિટ કરો',
    Save: 'સાચવો',
    Edit: 'સંપાદિત કરો',
    Show: 'બતાવો',
    Create: 'નવું બનાવો',
    'Last Opened': 'છેલ્લે ખોલ્યું',
    Delete: 'કાઢી નાંખવું',
    'Set Default': 'મૂળ રુપ માં મુકીયે',
    Reset: 'ફરીથી સેટ કરો',
    'Add More Information': 'વધુ માહિતી ઉમેરો',
    'Account Holder\'s Name': 'ખાતાધારકનું નામ',
    'Account Information': 'ખાતાની માહિતી',
    Production: 'ઉત્પાદન',
    Fertilizer: 'ખાતર',
    'Quantity to Sell': 'વેચવાની માત્રા',
    'Quantity to Sell Seed': 'બીજ વેચવાની માત્ર',
    Name: 'નામ',
    Title: 'શીર્ષક',
    Note: 'નૉૅધ',
    'Farmer\'s Directory': 'ખેડૂત પોથી',
    Surname: 'અટક',
    Gender: 'લિંગ',
    Male: 'પુરુષ',
    Female: 'સ્ત્રી',
    Adult: 'પુખ્ત વયના',
    Other: 'અન્ય',
    Marriage: 'લગ્ન',
    Husband: 'પતિ',
    Wife: 'પત્ની',
    Status: 'સ્થિતિ',
    'Brother Marriage': 'ભાઈના લગ્નની સ્થિતિ',
    'Sister Marriage': 'બહેનનાં લગ્નની સ્થિતિ',
    Yes: 'હા',
    No: 'ના',
    Widow: 'વિધવા',
    Brother: 'ભાઈ',
    Sister: 'બહેન',
    Address: 'સરનામું',
    Village: 'ગામ',
    Panchayat: 'પંચાયત',
    Taluko: 'તાલુકો',
    District: 'જીલ્લો',
    Mobile: 'મોબાઇલ',
    Whatsapp: 'વોટ્સેપ',
    Organization: 'સંગઠનનું નામ',
    Number: 'સભ્ય નંબર',
    'Total Family Count': 'કુટુંબની કુલ સંખ્યા',
    'This information is based on Count': 'આ માહિતી ગણતરી પર આધારિત છે',
    Family: 'કુટુંબ',
    Count: 'ગણતરી',
    Particular: 'વિશેષ',
    'SHG Member': 'સખી મંડળના સભ્ય',
    Children: 'બાળકો',
    Boy: 'છોકરો',
    Girl: 'છોકરી',
    'Play Group': 'આંગણવાડી',
    School: 'શાળા',
    Government: 'સરકારી',
    Scheme: 'યોજના',
    Benefits: 'લાભો',
    Information: 'માહિતી',
    'Aadhar Card': 'આધાર કાર્ડ',
    'Election Card': 'ચૂંટણી કાર્ડ',
    'Ration Card': 'રેશન કાર્ડ',
    Antyodaya: 'અંત્યોદય',
    Agratakram: 'અગ્રતાક્રમ',
    BPL: 'બી.પી.એલ.',
    APL: 'એ.પી.એલ',
    Bank: 'બેંક',
    'Bank Account': 'બેંક એકાઉન્ટ',
    Certificate: 'પ્રમાણપત્ર',
    Income: 'આવક',
    Cast: 'જાતિ',
    Photo: 'છબી',
    Proof: 'પુરાવો',
    Surpanch: 'સરપંચ',
    Talati: 'તલાટી કમ મંત્રી નું નામ',
    'Government Scheme Taken': 'સરકારી યોજના લીધી',
    'Government Scheme Not Taken': 'સરકારી યોજના લેવામાં આવી નથી',
    'Migration Duration': 'સ્થળાંતર અવધિ',
    'Migration with Family': 'પરિવાર સાથે સ્થળાંતર',
    'Migration with Family Location': 'પરિવાર સાથે સ્થળાંતરનું સ્થાન',
    'Migration Location': 'સ્થળાંતર સ્થાન',
    Education: 'શિક્ષણ',
    Acre: 'એકર',
    Guntha: 'ગુંઠા',
    Details: 'વિગતો',
    'NREGA Number': 'નરેગા નંબર',
    'Job-Card Number': 'જોબ-કાર્ડ નંબર',
    'Ayurvedic Land Details': 'આયુર્વેદિક ખેતીની જમીનની વિગતો',
    'Tendu Leaves Details': 'ટીમરુ પત્તા તોડો છો ?',
    'Honey Farming': 'મધની ખેતી',
    'Ayurvedic Forest Land': 'આયુર્વેદિક ખેતીની વન જમીન',
    'Forest Production': 'વન ઉત્પાદન',
    'Cultivation': 'ખેતી',
    'Forest Land (Claimed Land)': 'જંગલ જમીન (ખેડાણ હેઠળ કબજાવાળી)',
    'Forest Cultivation': 'જંગલ જમીન',
    'Residence': 'જંગલ જમીન પર ઉભી કરેલ મિલકત',
    'Forest Land House': 'ઘર',
    'Forest Land Well': 'કુવો',
    'Forest Land Engine': 'એન્જીન',
    'Forest Land Pala': 'પાળા',
    'Forest Land Trench': 'ક્યારા',
    'Forest Land Improvement Projects': 'જમીન સુધારણા',
    'Forest Land Evidence Book Registration': 'ખેડૂતપોથી નં',
    'Bunds (Forest Land Evidence Book Registration)': 'વાડ',
    'Trees (Forest Land Evidence Book Registration)': 'ઝાડ',
    'Pond (Forest Land Evidence Book Registration)': 'ખેત તલવાડી',
    'GPS Map (Forest Land Evidence Book Registration)': 'જીપીએસ નકશો',
    'Forest Land Entitlement Information': 'જંગલ જમીન ખેડાણ સનદ મળેલ',
    'Forest Land Received Through Receipt': 'ખેડાણ જમીન પાવતી આધારે મળેલ',
    'Forest Land Received Through Claim': 'કબજા આધારિત મળેલ',
    'Cultivating Land Measurement': 'ખેડાણ જમીન માપણી થઇ છે',
    'Natural Trees': 'વૃક્ષોની માહિતી (કુદરતી)',
    'Grown Trees': 'વૃક્ષોની માહિતી (ઉછેરેલા)',
    'Claim Application Number': 'દાવાની અરજી નંબર',
    'East (Claimed Land)': '(પૂર્વ) જંગલ જમીન ખેડાના ખુંટ',
    'West (Claimed Land)': '(પશ્ચિમ) જંગલ જમીન ખેડાના ખુંટ',
    'North (Claimed Land)': '(ઉત્તર) જંગલ જમીન ખેડાના ખુંટ',
    'South (Claimed Land)': '(દક્ષિણ) જંગલ જમીન ખેડાના ખુંટ',
    'Forest Land Nominees Names': 'વારસદારના નામો',
    'Revenue Land': 'રેવન્યુ જમીન છે',
    '7-12-8 Number': '૭/૧૨ ના દાખલાનંબર',
    'Revenue Land Inherited ?': 'રેવન્યુ જમીન વારસાઈ થઇ છે ?',
    'Revenue Land Livelihood ?': 'રેવન્યુ જમીન ખેડાણ પર આપનું જીવન નિર્વાહ પુરતું છે ?',
    'Revenue Land Irrigation Facility ?': 'સિચાઈ ની સુવિધા છે ?',
    'Monsoon Irrigation ?': 'વરસાદી ખેતી',
    'Government Graze Land (Monsoon) ?': 'સરકારી પડતર વરસાદી જમીન',
    'Government Graze Land Details': 'સરકારી પડતર જમીન',
    'Government Graze Forest Land': 'જંગલ જમીન',
    'Barren Land (Monsoon) ?': 'ગ્રાઝલેન્ડ / સરકાર ગ્રાઝલેન્ડ',
    Livelihood: 'આજીવિકા',
    'Monsoon Forest Land': 'ચોમાસા વાવેતર જમીન',
    'Monsoon Forest Land Details': 'ચોમાસા વાવેતર',
    'Summer Forest Land': 'ઉનાળો વાવેતર જમીન',
    'Summer Forest Land Details': 'ઉનાળો વાવેતર',
    'Winter Forest Land': 'શિયાળુ વાવેતર જમીન',
    'Winter Forest Land Details': 'શિયાળુ વાવેતર',
    'Revenue Forest Land': 'રેવન્યુ જમીન',
    'Revenue Forest Land Details': 'રેવન્યુ જમીન વાવેતર',
};
